export default __webpack_public_path__ + "static/flag-d5fcc61bf2e273ff6931012883ad59ed.gif";